// Exports:
export const LOCAL_STORAGE_KEYS = {
  USERNAME: 'username',
  TOKEN: 'token',
  EXPIRATION: 'expiration'
}
